import React from "react";
import {Button, CheckBox, ColorPickerBox, Column, Row, RowLR, Spinner, Text, TextInput, TimeSpanInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {Observer, TextPlus} from "web-vcore";
import {ControlInput} from "../../../@Shared/ControlInput.js";
import {EffectPointerInput} from "../../../@Shared/EffectPointerInput.js";
import {SpinnerForPercent} from "../../../../Utils/ReactComponents/SpinnerForPercent.js";
import {EngineConfigPanels_SharedProps, ExtendEngineConfigPanelSharedProps} from "../ConfigPanel_Local.js";
import {observer_mgl} from "mobx-graphlink";
import {SignalConfig} from "../../../../Server/DB/engineConfigs/@EngineConfig/@EC_Signals.js";
import {TriggerSet} from "../../../../Server/DB/engineConfigs/@TriggerSet.js";
import {ShowMessageBox} from "react-vmessagebox";
import {FieldLabel, flp} from "../../../@Shared/FieldLabel.js";
import {styles} from "../../../../Utils/UI/GlobalStyles.js";

const GetSharedProps = (props: EngineConfigPanels_SharedProps)=>ExtendEngineConfigPanelSharedProps(props, c=>c.signals, (c, v)=>c.signals = v);
type SharedProps_SignalsConfigUI = ReturnType<typeof GetSharedProps>;

const splitAt = 150;

export const Signals_ConfigUI = observer_mgl((props: {} & EngineConfigPanels_SharedProps)=>{
	const {client, enabled} = props;
	const sharedProps = GetSharedProps(props);
	const {config, ChangeConfig} = sharedProps;

	return (
		<Column mt={15} style={{...styles.darkenedBox_configPage}}>
			<Row style={{fontSize: 18}}>
				<CheckBox text="Signals" enabled={enabled} value={config.enabled} onChange={val=>ChangeConfig(c=>c.enabled = val)}/>
			</Row>

			{config.enabled &&
			<>
				<Row mt={5}>
					<Text>Signals:</Text>
					<Button ml={5} mdIcon="plus" onClick={()=>{
						const newSignal = new SignalConfig({
							name: `Signal${(config.signals.length ?? 0) + 1}`,
							triggerSet: new TriggerSet({}),
						});
						ChangeConfig(a=>a.signals = (a.signals ?? []).concat(newSignal));
					}}/>
				</Row>
				{config.signals.map((signal, index)=>{
					return (
						<SignalConfigUI key={index} {...sharedProps} index={index} signal={signal}/>
					);
				})}
			</>}
		</Column>
	);
});

const SignalConfigUI = (props: {index: number, signal: SignalConfig} & SharedProps_SignalsConfigUI)=>{
	const {index, signal, enabled, ChangeConfig} = props;
	const fp = (fieldName: keyof SignalConfig)=>`signals.signals.${index}.${fieldName}`;

	return (
		<Column mt={5} style={{background: "rgba(0,0,0,.5)", borderRadius: 5, padding: 5}}>
			<Row>
				<Text>Signal {index + 1}:</Text>
				<Button ml="auto" mdIcon="delete" title="Delete" enabled={enabled} onClick={()=>{
					ShowMessageBox({
						title: "Delete signal", cancelButton: true,
						message: `Delete signal "${signal.name}"?`,
						onOK: ()=>{
							ChangeConfig(a=>a.signals!.RemoveAt(index));
						},
					});
				}}/>
			</Row>
			<RowLR mt={5} splitAt={splitAt}>
				<FieldLabel text="Name:" fieldPath={fp("name")}/>
				<TextInput enabled={enabled} value={signal.name} onChange={val=>ChangeConfig(c=>c.signals[index].name = val)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt}>
				<FieldLabel text="Trigger set:" fieldPath={fp("triggerSet")}/>
				<ControlInput enabled={enabled} value={signal.triggerSet} onChange={val=>ChangeConfig(c=>c.signals[index].triggerSet = val)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt}>
				<FieldLabel text="Effect:" fieldPath={fp("effect")}/>
				<EffectPointerInput enabled={enabled} value={signal.effect} onChange={val=>ChangeConfig(c=>c.signals[index].effect = val)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt}>
				<Text p={flp}>Graph...</Text>
				<Text>Color:</Text>
				<ColorPickerBox ml={5} color={(signal.graphColor ?? [255,255,255]) as [number,number,number]} onChange={val=>ChangeConfig(c=>c.signals[index].graphColor = val)}/>
				<Text ml={5}>VMin:</Text>
				<SpinnerForPercent ml={5} enabled={enabled} value={signal.graphVMin ?? 0} onChange={val=>ChangeConfig(c=>c.signals[index].graphVMin = val)}/>
				<Text ml={5}>VMax:</Text>
				<SpinnerForPercent ml={5} enabled={enabled} value={signal.graphVMax ?? 1} onChange={val=>ChangeConfig(c=>c.signals[index].graphVMax = val)}/>
			</RowLR>
		</Column>
	);
};